import { language } from "@chef/constants";
import { useBillingQuery } from "@chef/state-management";
import { CancelSubscriptionButtonComponent } from "./CancelSubscriptionButtonComponent";

interface Props {
  onConfirm: () => void;
  linkToPauseSubscriptionForPeriodPage: string;
  id?: string;
}

export const CancelSubscriptionButton = ({
  onConfirm,
  linkToPauseSubscriptionForPeriodPage,
  id,
}: Props) => {
  const { data } = useBillingQuery();

  return (
    <CancelSubscriptionButtonComponent
      discounts={data?.billing.discounts}
      id={id}
      onConfirm={onConfirm}
      language={language}
      linkToPauseSubscriptionForPeriodPage={
        linkToPauseSubscriptionForPeriodPage
      }
    />
  );
};
